import React, { useState, useRef, useEffect  } from 'react';
import { GenericButton } from '../buttons/customButtons';
import { TT_DELETE } from '../i18n/toolTips';
import {Spinner} from "reactstrap";
import PropTypes from "prop-types";

export const ImagePickerInputV2 = ({ fbMediaConfig, objectMedia, type, lang, onAddImage, baseMediaService, parent, afterUpload }) => {
    const { fieldCode, className, useGallery, use18n, use18nSameImage, useThumb, path, id: fbMediaConfigId} = fbMediaConfig;
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const fileInputRef = useRef(null);
    const allowedTypes = fbMediaConfig.formatsAllowed.map(item => `image/${item}`).join(', ');
    const [perm, setPerm] = useState(null);
    const [media, setMedia] = useState(objectMedia);

    const renderSuffix = () => {
        if(use18n && !use18nSameImage){
            if(type==="thumb"){
                return (lang + "_thumb");
            }

            return  lang;
        }

        if(type==="thumb"){
            return "thumb";
        }
        // TODO: Implementar el renderizado de sufijos para el caso de useGallery
        // if(useGallery){
        //     if(index > 0){
        //         return index;
        //     }
        // }
        return "";
    }

    useEffect(() => {
        let _perm = (localStorage.getItem('permission') !== '' ? JSON.parse(localStorage.getItem('permission')) : null);

        if (_perm) {
            setPerm(_perm);
        }
    }, []);

    const refreshMedia = (data) =>{
        if(!useGallery && fieldCode!=="image"){
            // service.updateItem(
            //     objectMedia.id, {
            //         fbDataBase: { id: fbDataBase.id },
            //         item: {
            //             id: objectMedia.id,
            //             [fieldCode]: data.media.file
            //         }
            //     }
            // );
        }
        afterUpload();
        setMedia(data);
        setLoading(false);
        onAddImage();
    }

    const handleFileChange = async (e) => {
        const newFiles = Array.from(e.target.files);
        setLoading(true);

        const updatedFiles = [...files, ...newFiles];
        setFiles(updatedFiles);

        for (let i = 0; i < newFiles.length; i++) {
            const newFile = newFiles[i];
            const reader = new FileReader();

            reader.onloadend = async () => {


                const formData = new FormData();
                formData.set('showOrder', files.length + i);
                formData.set(className, parent?.id);

                formData.set('name', newFile.name);
                formData.set('className', className);
                formData.set('fieldCode', fieldCode);
                formData.set('path', path);
                formData.set('suffix', renderSuffix()) // renderSuffix((mediaList?.length || 0) + 1));
                formData.set('status', true);
                formData.set('img', newFile);
                formData.set('fbMediaConfig', fbMediaConfigId);

                try {
                    const data  = await baseMediaService.saveItem(formData);
                    if(data){
                        refreshMedia(data);
                    }else{
                        setLoading(false);
                    }
                } catch (error) {
                    console.error("Error uploading image:", error);
                    setLoading(false);
                }
            };

            reader.readAsDataURL(newFile);
        }


    };

    const handleRemoveImage = () => {
        setLoading(true);
        baseMediaService.deleteItem( media.id )
            .then(() => {
                setMedia(undefined);
                setFiles(prevFiles => prevFiles.filter((p, i) => p.id !== media.id));
            })
            .catch((error) => {
                console.error("Error deleting image:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleFileClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    return (
        <>
            <div className="image-picker-container"
                 style={type === 'thumb' ? {maxWidth: '130px', minWidth: '130px', height: '135px'} : {}}>
                <div className="image-picker-control-container">
                    { loading && <Spinner/> }
                    {!loading && <>
                        {
                            media === undefined ?
                                <label>
                                    <input
                                        type="file"
                                        onChange={handleFileChange}
                                        style={{display: 'none'}}
                                        accept={allowedTypes}
                                        ref={fileInputRef}
                                        multiple={fbMediaConfig.useGallery}
                                        disabled={!perm?.allowGallery}
                                    />
                                    <button type="button" onClick={handleFileClick}>
                                        <i className="fas fa-upload"
                                           style={{fontSize: '2em', marginBottom: '10px', color: '#aaa'}}></i>
                                    </button>
                                </label> :
                                <div key={media?.id} className="image-preview">
                                    <div className="image-picker-delete">
                                        <GenericButton
                                            style="danger-secondary"
                                            toolTip={TT_DELETE}
                                            icon="fa-trash"
                                            permission="delete"
                                            onClick={() => handleRemoveImage()}
                                        />
                                    </div>
                                    <img alt={`Preview ${media.fieldCode}`} src={ media?.media?.url }/>
                                </div>
                        }
                    </>
                    }
                    <p style={{margin: 0}}>{type === 'thumb' ? 'Miniatura' : 'Imagen'} {lang && ` (${lang})`}</p>
                </div>
            </div>
            {
                !loading && fbMediaConfig.useGallery && <>
                    <div className="image-picker-container">
                        <div className="image-picker-control-container">
                            <label>
                                <input
                                    type="file"
                                    onChange={handleFileChange}
                                    style={{display: 'none'}}
                                    accept={allowedTypes}
                                    ref={fileInputRef}
                                    multiple={fbMediaConfig.useGallery}
                                    disabled={!perm?.allowGallery}
                                />
                                <button type="button" onClick={handleFileClick}>
                                    <i className="fas fa-upload"
                                       style={{fontSize: '2em', marginBottom: '10px', color: '#aaa'}}></i>
                                </button>
                            </label>
                            <p style={{margin: 0}}>{type === 'thumb' ? 'Miniatura' : 'Imagen'} {lang && ` (${lang})`}</p>
                        </div>
                    </div>
                </>
            }
        </>
    );
};

export default ImagePickerInputV2;

ImagePickerInputV2.propTypes = {
    objectMedia: PropTypes.object,
    type: PropTypes.string.isRequired,
    fbMediaConfig: PropTypes.object.isRequired,
    onAddImage: PropTypes.func.isRequired,
    service: PropTypes.object
}